export const COLUMN_PARAMS = {
  is_use: '상태',
  created_at: '상품등록일',
  updated_at: '상품수정일',
  deleted_at: '판매종료일',
  brand: '브랜드명',
  brand_jp: '브랜드명(일본어)',
  brand_en: '브랜드명(영어)',
  sku_code: 'SKU 코드',
  name: 'SKU 상품명',
  name_jp: 'SKU 상품명(일본어)',
  name_en: 'SKU 상품명(영어)',
  barcode: '바코드',
  stock: '현재재고수량',
  safe_stock: '안전재고수량',
  expiration_date: '상태',
  currency: '화폐단위',
  sale_price: '판매가',
  list_price: '정가',
  yomigana: '요미가나',
  made_in_country: '제조국',
  hs_code: 'HS 코드',
  weight: '무게(g)',
  carrier_name: '매칭 운송사명',
};
